// extracted by mini-css-extract-plugin
module.exports = {"TraineCar":"TraineCar_TraineCar__lvXuD","traineCar":"TraineCar_traineCar__3kwbB","wheel":"TraineCar_wheel___EuUF","secondWhell":"TraineCar_secondWhell__1pNZD"};